import { useContent } from "@/lib/content";
import { Seo } from "@/components/Seo";

// Editable page header (Site content → page key): Google title/description + optional banner photo.
export function PageIntro({ page, children }) {
  const c = useContent(page);
  if (!c) return <div className="min-h-[180px]"/>;
  const { intro, seo } = c;
  return (
    <>
      <Seo title={seo.meta_title} description={seo.meta_description} image={seo.og_image || intro.image}/>
      {intro.image && (
        <div className="h-56 md:h-72 -mt-6 mb-10 rounded-2xl overflow-hidden relative" data-testid={`${page}-banner`}>
          <img src={intro.image} alt={intro.image_alt} className="w-full h-full object-cover"/>
          <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"/>
        </div>
      )}
      <div className="jt-eyebrow mb-3" data-testid={`${page}-eyebrow`}>{intro.eyebrow}</div>
      <h1 className="font-serif text-4xl md:text-5xl text-[#1E3A2B] mb-3" data-testid={`${page}-title`}>{intro.title}</h1>
      {intro.subtitle && <p className="text-[#5C6B63] max-w-2xl mb-8" data-testid={`${page}-subtitle`}>{intro.subtitle}</p>}
      {children}
    </>
  );
}
